// Import order is the interface's module contract. Modules publish their public
// symbols to window; app.jsx mounts only after every dependency is available.
import "../public/studio/src/data.jsx";
import "../public/studio/src/site-settings.jsx";
import "../public/studio/src/activity.jsx";
import "../public/studio/src/sourcemap-data.jsx";
import "../public/studio/src/concepts.jsx";
import "../public/studio/src/workspace.jsx";
import "../public/studio/src/analytics.jsx";
import "../public/studio/src/dictionary.jsx";
import "../public/studio/src/account-sync.jsx";
import "../public/studio/src/anim.jsx";
import "../public/studio/src/components.jsx";
import "../public/studio/src/sourcemap.jsx";
import "../public/studio/src/tweaks-panel.jsx";
import "../public/studio/src/home.jsx";
import "../public/studio/src/maamarim-beta-data.jsx";
import "../public/studio/src/likkutei-sichos-beta-data.jsx";
import "./studio-beta-data-fixes.jsx";
import "../public/studio/src/library.jsx";
import "../public/studio/src/topic.jsx";
import "../public/studio/src/print.jsx";
import "../public/studio/src/reader.jsx";
import "../public/studio/src/research.jsx";
import "../public/studio/src/explore.jsx";
import "../public/studio/src/compare.jsx";
import "../public/studio/src/palette.jsx";
import "../public/studio/src/mobile.jsx";
import "../public/studio/src/analytics-admin.jsx";
import "../public/studio/src/site-pages.jsx";
import "../public/studio/src/app.jsx";
import "../public/studio/src/live.jsx";
